import React from "react";
import styled from "styled-components";

export const MenuContainer = styled.div`
  width: max-content;
  color: var(--primary-fg);
`;

const MenuListItem = styled.button<{ disabled?: boolean }>`
  padding: 0px 12px;
  font-size: 16px;
  font-weight: 400;
  line-height: 44px;
  cursor: pointer;
  display: block;
  background: transparent;
  border: none;

  :disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

export interface MenuItem {
  key: string;
  label: string;
  disabled?: boolean;
  onClick: () => void;
}

type Props = {
  menuItems: Map<string, MenuItem[]>;
};

const Menu = ({ menuItems }: Props): JSX.Element => (
  <MenuContainer>
    {Array.from(menuItems).map(([header, items]) => (
      <React.Fragment key={header}>
        {items.map((item) => (
          <MenuListItem
            data-testid={`menu-item[${item.key}]`}
            key={item.key}
            onClick={item.onClick}
            disabled={item.disabled}
          >
            {item.label}
          </MenuListItem>
        ))}
      </React.Fragment>
    ))}
  </MenuContainer>
);

export default Menu;
